import React, { useState  , useEffect} from 'react'
import Language  from '../Context/Language';
import { useContext } from 'react'
import Context  from '../Context/Context';
import {
    useNavigate,
    useLocation
     
  } from "react-router-dom";



export default function LanguageModel() {
    const data = useContext(Language);
    const dataCon = useContext(Context);
    const navigate = useNavigate()
    const location = useLocation()



    const LangTr = () => {
        data.setlang("tr")
        sessionStorage.setItem("lang","tr")
        if(location.pathname.split("/")[1] == "tr" || location.pathname.split("/")[1] == "en" || location.pathname.split("/")[1] == "de") {
            navigate('/tr')
        }
        else{
            navigate(`${location.pathname.split("/")[1]}/${location.pathname.split("/")[2]}/${location.pathname.split("/")[3]}/${location.pathname.split("/")[4]}/${location.pathname.split("/")[5]}/tr`)
        }
    
        dataCon.setLanguageModelDis(false)
   
    }
    const LangEn = () => {
        data.setlang("en")
        sessionStorage.setItem("lang","en")
        if(location.pathname.split("/")[1] == "tr" ||  location.pathname.split("/")[1] == "en" || location.pathname.split("/")[1] == "de") {
            navigate('/en')
        }
        else{
            navigate(`${location.pathname.split("/")[1]}/${location.pathname.split("/")[2]}/${location.pathname.split("/")[3]}/${location.pathname.split("/")[4]}/${location.pathname.split("/")[5]}/en`)
        }
        dataCon.setLanguageModelDis(false)
    }
    const LangDe = () => {
        data.setlang("de")
        sessionStorage.setItem("lang","de")
        if(location.pathname.split("/")[1] == "tr" || location.pathname.split("/")[1] == "en" || location.pathname.split("/")[1] == "de") {
            navigate('/de')
        }
        else{
            navigate(`${location.pathname.split("/")[1]}/${location.pathname.split("/")[2]}/${location.pathname.split("/")[3]}/${location.pathname.split("/")[4]}/${location.pathname.split("/")[5]}/de`)
        }
        dataCon.setLanguageModelDis(false)
    }

  return (
    <div className='LanguageModelContainer'>
         <div onClick={LangTr} className='LanguageModelArea'>
             <img src='/tr.png' width={25} height={25}></img>
             <div className='LanguageModelText'>tr</div>
         </div>
         <div onClick={LangEn} className='LanguageModelArea'>
             <img src='/en.png' width={25} height={25}></img>
             <div className='LanguageModelText'>en</div>
         </div>
         <div onClick={LangDe} className='LanguageModelArea'>
             <img src='/de.png' width={25} height={25}></img>
             <div className='LanguageModelText'>de</div>
         </div>
    </div>
  )
}
